import { ACTIONS } from '../actions';
import { pluginKey } from '../key';
export var closeTypeAhead = function closeTypeAhead(tr) {
  return tr.setMeta(pluginKey, {
    action: ACTIONS.CLOSE_TYPE_AHEAD
  });
};